import React from 'react'
import { useNavigate } from 'react-router-dom'

interface CarpoolDashboardLinkProps {
  userId: string
  communityId: string
  users: Array<{
    userId: string
    userCommunityId?: string
    userCommunityStudentId?: string
  }>
  message: string
  className?: string
}

const CarpoolDashboardLink: React.FC<CarpoolDashboardLinkProps> = ({
  userId,
  communityId,
  users,
  message,
  className = 'justify-end',
}) => {
  const navigate = useNavigate()

  // Find user and student ID during render
  const user = users.find((v) => v.userId === userId && v.userCommunityId === communityId)
  const myStudentId = user?.userCommunityStudentId

  // Don't render anything if no student ID is found
  if (!myStudentId) {
    return null
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    navigate(`/carpool/dashboard?id=${myStudentId}`)
  }

  const baseClasses = 'flex'
  const containerClasses = className ? `${baseClasses} ${className}` : baseClasses

  return (
    <div className={containerClasses}>
      <button
        onClick={handleClick}
        className='text-xs text-gray-700 hover:text-gray-900 hover:underline flex items-center font-medium transition-colors duration-200'
      >
        <span>{message}</span>
        <svg className='ml-1 w-3.5 h-3.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2.5} d='M9 5l7 7-7 7' />
        </svg>
      </button>
    </div>
  )
}

export default CarpoolDashboardLink
